import React, { useState } from 'react';
import styles from './prefooter.module.css';
import { Icons } from '../../atoms/icons/index';
import { RegionLink, staticLinks, titles } from './prefooterData';

interface PrefooterProps {
    regionContent: RegionLink[] | null;  
}

const Prefooter: React.FC<PrefooterProps> = ({ regionContent }) => {
	const [openDropdown, setOpenDropdown] = useState<number | null>(null);

	const toggleDropdown = (index: number) => {
		setOpenDropdown(openDropdown === index ? null : index);
	};

	return (
		<div className={styles.prefooter}>
			<h2 className={styles.mainTitle}>Lo más buscado</h2>
			<div className={styles.columnsContainer}>
				{staticLinks.map((column, index) => (
					<div key={titles[index]} className={styles.column}>
						<div className={styles.titleDesktop}>{titles[index]}</div>
						<button onClick={() => toggleDropdown(index)} className={styles.dropdownButton}>
							{titles[index]}
							<Icons iconName="iconDown" w={16} h={9} fill="#000" class={`${openDropdown === index ? styles.rotate : ''}`} />
						</button>
						<div className={styles.dropdownContent + " " + (openDropdown === index ? styles.active : "")}>
							{column.map((link) => (
								<a key={link.url} href={link.url}>{link.label}</a>
							))}
						</div>
					</div>
				))}
				{regionContent && regionContent.map((category, categoryIndex) => (
					<div key={category.title} className={styles.column}>
						<div className={styles.titleDesktop}>{category.title}</div>
						<button onClick={() => toggleDropdown(staticLinks.length + categoryIndex)} className={styles.dropdownButton}>
							{category.title}
							<Icons iconName="iconDown" w={16} h={9} fill="#000" class={`${openDropdown === (staticLinks.length + categoryIndex) ? styles.rotate : ''}`} />
						</button>
						<div className={styles.dropdownContent + " " + (openDropdown === (staticLinks.length + categoryIndex) ? styles.active : "")}>
							{category.links.map((link) => (
								<a key={link.url + link.label} href={link.url}>{link.label}</a>
							))}
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default Prefooter;
